import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=f66a89ea&scoped=true&"
import script from "./Recruitment.vue?vue&type=script&lang=ts&"
export * from "./Recruitment.vue?vue&type=script&lang=ts&"
import style0 from "./Recruitment.vue?vue&type=style&index=0&id=f66a89ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66a89ea",
  null
  
)

export default component.exports